import { hoatDongHangHangApi } from '../../../api/hoatDongHangHangApi';
import { IHoatDongHangNgaySelectRequest } from '../../../models/request/danh-gia/IHoatDongHangNgaySelectRequest';
import { IHoatDongHangNgaySubmitRequest } from '../../../models/request/danh-gia/IHoatDongHangNgaySubmitRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IDiemDanh } from '../../../models/response/danh-gia/IDiemDanh';
import { INhanXetHangNgay } from '../../../models/response/danh-gia/INhanXetHangNgay';
import { INhanXetHangNgayLop } from '../../../models/response/danh-gia/INhanXetHangNgayLop';
import { eHoatDongHangNgayActionTypeIds, IHoatDongHangNgayActions } from '../../action-types/diem-danh/IHoatDongHangNgayActionType';
import { actions } from '../../actions/actionsWrapper';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

const mainAction = actions.danhGia.hoatDongHangNgay;
export function* hoatDongHangNgaySaga(): any {
    yield takeLatest(eHoatDongHangNgayActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eHoatDongHangNgayActionTypeIds.SUBMIT_DIEM_DANH_START, submitDiemDanhWorker)
    yield takeEvery(eHoatDongHangNgayActionTypeIds.SUBMIT_NHAN_XET_LOP_START, submitNhanXetChung)
    yield takeEvery(eHoatDongHangNgayActionTypeIds.SUBMIT_NHAN_XET_HOC_SINH_START, submitNhanXetHocSinh)
}

function* loadWorker(action: IHoatDongHangNgayActions): any {
    const res: IBaseResponeModel = yield call(hoatDongHangHangApi.SelectByLop, action.payload as IHoatDongHangNgaySelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* submitDiemDanhWorker(action: IHoatDongHangNgayActions): any {
    const res: IBaseResponeModel = yield call(hoatDongHangHangApi.SubmitDiemDanh, action.payload as IHoatDongHangNgaySubmitRequest<IDiemDanh[]>)
    if (res.is_success) {
        yield put(mainAction.SUBMIT_DIEM_DANH_SUCCESS(res.data))
    } else {
        yield put(mainAction.SUBMIT_DIEM_DANH_ERROR(res.message ?? "Có lỗi"))
    }
}

function* submitNhanXetChung(action: IHoatDongHangNgayActions): any {
    const res: IBaseResponeModel = yield call(hoatDongHangHangApi.SubmitNhanXetLop, action.payload as IHoatDongHangNgaySubmitRequest<INhanXetHangNgayLop>)
    if (res.is_success) {
        yield put(mainAction.SUBMIT_NHAN_XET_LOP_SUCCESS(res.data))
    } else {
        yield put(mainAction.SUBMIT_NHAN_XET_LOP_ERROR(res.message ?? "Có lỗi"))
    }
}

function* submitNhanXetHocSinh(action: IHoatDongHangNgayActions): any {
    const res: IBaseResponeModel = yield call(hoatDongHangHangApi.SubmitNhanXetHocSinh, action.payload as IHoatDongHangNgaySubmitRequest<INhanXetHangNgay[]>)
    if (res.is_success) {
        yield put(mainAction.SUBMIT_NHAN_XET_HOC_SINH_SUCCESS(res.data))
    } else {
        yield put(mainAction.SUBMIT_NHAN_XET_HOC_SINH_ERROR(res.message ?? "Có lỗi"))
    }
}